import React, {Component} from 'react';
import {renderWithNamespace, renderResourceTitle} from '../utils/Functions'
import $ from "jquery";

import loading from "../img/loading-new-nero@2x.gif"
import {v4 as uuidv4} from "uuid";
// eslint-disable-next-line no-template-curly-in-string
const directPropertyValue = "select distinct ?o {<$SUBJ> <$PROP_IRI> ?o.} OFFSET ${STARTFROM} LIMIT 10 "
// eslint-disable-next-line no-template-curly-in-string
const inversePropertyValue = "select distinct ?o {?o <$PROP_IRI> <$SUBJ>.} OFFSET ${STARTFROM} LIMIT 10 "


class PropertyAutoload extends Component {
	constructor(props) {
		super(props);

		this.state = {
			propertyIRI: props.propertyIRI,
			subjectIri: props.subject,
			propertyCount: props.count,
			propertyValues: [],
			propertyValuesRendered: [],
			loadingVisibility: "visible",
			offset: 0,
			direct: props.direct

		}
		// console.log(this.state);
	}


	renderBeforeMount = () => {
		let me = this
		me.setState({loadingVisibility: "visible"})

		$.ajax({
			//  url: 'https://lila-erc.eu/sparql/lemmaBank/query?format=csv&query=' + encodeURIComponent(query),
			// eslint-disable-next-line no-template-curly-in-string
			url: 'https://lila-erc.eu/sparql/lila_knowledge_base/query?format=json&query=' + encodeURIComponent(
				this.state.direct ?
					// eslint-disable-next-line no-template-curly-in-string
					directPropertyValue.replaceAll("$SUBJ", this.state.subjectIri).replaceAll("$PROP_IRI", this.state.propertyIRI).replaceAll("${STARTFROM}", this.state.offset)
					:
					// eslint-disable-next-line no-template-curly-in-string
					inversePropertyValue.replaceAll("$SUBJ", this.state.subjectIri).replaceAll("$PROP_IRI", this.state.propertyIRI).replaceAll("${STARTFROM}", this.state.offset)
			),
			async: true,
			dataType: "json",

			success: function (data) {
				let properties = data.results.bindings

				me.setState({propertyValues: properties, propertyValuesRendered: []}, () => {
					if (me.state.propertyValues.length <= 10) {
						me.state.propertyValues.forEach((propertyObj) => {
							let property = propertyObj.o;
							if (property.type === "uri") {
								renderResourceTitle(property.value).then(res => {
									let pTemp = me.state.propertyValuesRendered
									// console.log(res)
									pTemp.push(res)
									me.setState({propertyValuesRendered: pTemp}, () => {
										me.setState({loadingVisibility: "hidden"})
									})
								});

							} else {
								let pTemp = me.state.propertyValuesRendered
								pTemp.push(<div key={uuidv4()} className="">
									{property.value} <span key={uuidv4()}
									                       className={"elang"}>{(Object.hasOwn(property, 'xml:lang') ? "@" + property["xml:lang"] : "")}</span>
								</div>)
								me.setState({propertyValuesRendered: pTemp}, () => {
									me.setState({loadingVisibility: "hidden"})
								})

							}
						})
					} else {
						// console.log("more then 50")

						for (let i = 0; i < 10; i++) {
							let property = me.state.propertyValues[i].o;
							if (property.type === "uri") {
								renderResourceTitle(property.value).then(res => {
									let pTemp = me.state.propertyValuesRendered
									// console.log(res)
									pTemp.push(res)
									me.setState({propertyValuesRendered: pTemp})
								});

							} else {
								let pTemp = me.state.propertyValuesRendered
								pTemp.push(<div className="">
									{property.value}
								</div>)
								me.setState({propertyValuesRendered: pTemp})

							}
						}


					}
				})
				// me.setState({propertyValuesRendered: pTemp})
				// callback(data)
			}

		});


	}


	componentDidMount() {
		this.renderBeforeMount();
	}


	next = () => {
		let me = this
		let newoffset = this.state.offset + 10;
		if (newoffset < this.state.propertyCount) {
			me.setState({offset: newoffset}, () => {
				this.renderBeforeMount();
			})
		}
	}
	prev = () => {
		let me = this
		let newoffset = this.state.offset - 10;
		if (newoffset >= 0) {
			me.setState({offset: newoffset}, () => {
				this.renderBeforeMount();
			})
		}
	}

	render() {
		return (
			<tr>
				<td><label className="">
					<a data-label="" data-comment="" href={this.state.propertyIRI}>
						{/*{this.state.propertyIRI}*/}

						{this.state.direct ? renderWithNamespace(this.state.propertyIRI) : <div
							style={{"whiteSpace": "nowrap"}}>is <span>{renderWithNamespace(this.state.propertyIRI)}</span> of
						</div>}

					</a></label></td>
				<td style={{width: "100%"}}>

					<>
						{this.state.propertyCount > 10 ?
							<>
								{this.state.propertyCount + " resources"}
								{/* eslint-disable-next-line jsx-a11y/anchor-has-content,jsx-a11y/anchor-is-valid */}
								<span className={"prevArrow sp"} onClick={() => {
									this.prev()
								}}
								      style={{opacity: "1", cursor: "default"}}/>
								{/* eslint-disable-next-line jsx-a11y/anchor-has-content,jsx-a11y/anchor-is-valid */}
								<span className={"nextArrow sp"} onClick={() => {
									this.next()
								}}/> <img src={loading} alt={"loading"} style={{
								height: "60%",
								marginLeft: "10px",
								visibility: this.state.loadingVisibility
							}}/>

							</>
							: ""}

					</>
					<div className="c2 value"
					     style={{"marginTop": "0px", "visibility": "visible"}}>

						{this.state.propertyValuesRendered.map((property) => {
							return property
						})}
					</div>
				</td>
			</tr>
		);
	}
}

export default PropertyAutoload;